import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import AfiliacionView from '../views/amazon/AfiliacionView.vue'
import ListAsins from '../views/amazon/ListAsins.vue'
import TextEditor from '../views/TextEditor.vue'
import AuthView from '../views/AuthView.vue'

import MisasView from '@/views/misas/MisasView.vue'
import PrivacyPolicy from '@/views/other/PrivacyPolicy.vue'

import CodeIndexView from '@/views/code/CodeIndex.vue'
import CodeSublimeView from '@/views/code/CodeSublimeView.vue'
import IconsGenerator from '@/views/code/IconsGenerator.vue'
import CodeJavadocView from '@/views/code/JavadocView.vue'
import Typedef2Interface from '@/views/code/Typedef2Interface.vue'
import SecretShare from '@/views/code/SecretShare.vue'

import PregnacyView from '@/views/dates/PregnacyView.vue'
import SettingsView from '@/views/settings/SettingsView.vue'
import TodosViewVue from '@/views/Tasks/TodosView.vue'
import TasksView from '@/views/Tasks/TasksView.vue'
import BarcodeScanner from '@/views/BarcodeScanner.vue'
import FoodView from '@/views/food/FoodView.vue'
import MenusView from '@/views/food/MenusView.vue'
import FoodDetail from '@/views/food/FoodDetail.vue'

import FriendsView from '@/views/friends/FriendsView.vue'

import GCalendarView from '@/views/gcalendar/GCalendarView.vue'
import CalendarEdit from '@/views/gcalendar/CalendarEdit.vue'

import QuotesView from '@/views/quotes/QuotesView.vue'
import AutonomoView from '@/views/autonomo/AutonomoView.vue'

import RocioView from '@/views/other/RocioView.vue'

import GroceriesView from '@/views/food/GroceriesView.vue'
import BabyHome from '@/views/baby/BabyHome.vue'
import DiabetesHome from '@/views/diabetes/DiabetesHome.vue'
import UploadFile from '@/views/uploadfile/UploadFile.vue'
import BabyEventEdit from '@/views/baby/BabyEventEdit.vue'

import ListDetails from '@/views/watchlist/v2/ListDetails.vue'
//import WatchilstView from '@/views/watchlist/WatchilstView.vue'
import MyLists from '@/views/watchlist/v2/MyLists.vue'
import RecommendedView from '@/views/watchlist/RecommendedView.vue'
import SearchMovie from '@/views/watchlist/SearchMovie.vue'

import MovieDetailPage from '@/views/watchlist/v2/MovieDetailPage.vue'
import ExpensesHome from '@/views/expenses/ExpensesHome.vue'
import ExpensesUpload from '@/views/expenses/ExpensesUpload.vue'
import ExpensesMerged from '@/views/expenses/ExpensesMerged.vue'
import CoinbaseMerged from '@/views/expenses/CoinbaseMerged.vue'

import CampaignsView from '@/views/regalos/CampaignsView.vue'
import CampaignEdit from '@/views/regalos/CampaignEdit.vue'
import CampaignView from '@/views/regalos/CampaignView.vue'
import IdeaView from '@/views/regalos/IdeaView.vue'
import IdeaEdit from '@/views/regalos/IdeaEdit.vue'
import OpcionView from '@/views/regalos/OpcionView.vue'
import OpcionEditView from '@/views/regalos/OpcionEditView.vue'
import PurchasedTotalList from '@/views/regalos/PurchasedTotalList.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requiresAuth: true,
      title: 'Home',
    },
  },
  {
    path: '/expenses',
    name: 'ExpensesHome',
    component: ExpensesHome,
    meta: {
      requiresAuth: true,
      title: 'Expenses',
    },
  },
  {
    path: '/expenses/upload',
    name: 'ExpensesUpload',
    component: ExpensesUpload,
    meta: {
      requiresAuth: true,
      title: 'ExpensesUpload',
    },
  },
  {
    path: '/expenses/merged',
    name: 'ExpensesMerged',
    component: ExpensesMerged,
    meta: {
      requiresAuth: true,
      title: 'ExpensesMerged',
    },
  },
  {
    path: '/expenses/coinbase-merged',
    name: 'CoinbaseMerged',
    component: CoinbaseMerged,
    meta: {
      requiresAuth: true,
      title: 'CoinbaseMerged',
    },
  },

  {
    path: '/regalos',
    name: 'CampaignsView',
    component: CampaignsView,
    meta: {
      requiresAuth: true,
      title: 'Regalos',
      hideMenu: true, //maybe too much
    },
  },
  {
    path: '/regalos/campaign/:campaign_id',
    name: 'CampaignView',
    component: CampaignView,
    meta: {
      requiresAuth: true,
      title: 'Campaign',
      hideMenu: true,
    },
    props: true,
  },
  {
    path: '/regalos/campaign/:campaign_id/edit',
    name: 'CampaignEdit',
    component: CampaignEdit,
    meta: {
      requiresAuth: true,
      title: 'Campaign Edit',
      hideMenu: true,
    },
    props: true,
  },

  {
    path: '/regalos/campaign/:campaign_id/idea/:idea_id',
    name: 'IdeaView',
    component: IdeaView,
    meta: {
      requiresAuth: true,
      title: 'Idea',
      hideMenu: true,
    },
    props: true,
  },
  {
    path: '/regalos/campaign/:campaign_id/idea/:idea_id/edit',
    name: 'IdeaEdit',
    component: IdeaEdit,
    meta: {
      requiresAuth: true,
      title: 'Idea',
      hideMenu: true,
    },
    props: true,
  },
  {
    path: '/regalos/campaign/:campaign_id/idea/:idea_id/option/:option_id/edit',
    name: 'OpcionEditView',
    component: OpcionEditView,
    meta: {
      requiresAuth: true,
      title: 'Option Edit',
      hideMenu: true,
    },
    props: true,
  },
  {
    path: '/regalos/campaign/:campaign_id/idea/:idea_id/option/:option_id/view',
    name: 'OpcionView',
    component: OpcionView,
    meta: {
      requiresAuth: true,
      title: 'Option',
      hideMenu: true,
    },
    props: true,
  },

  {
    path: '/regalos/purchased',
    name: 'PurchasedTotalList',
    component: PurchasedTotalList,
    meta: {
      requiresAuth: true,
      title: 'Option',
      hideMenu: true,
    },
    props: true,
  },

  //-----------------
  {
    path: '/baby-tracker',
    name: 'BabyTracker',
    component: BabyHome,
    meta: {
      requiresAuth: true,
      title: 'Baby Tracker',
    },
  },
  {
    path: '/diabetes',
    name: 'DiabetesHome',
    component: DiabetesHome,
    meta: {
      requiresAuth: true,
      title: 'Diabetes',
    },
  },
  {
    path: '/uploadfile',
    name: 'UploadFile',
    component: UploadFile,
    meta: {
      requiresAuth: true,
      title: 'Upload File',
    },
  },
  {
    path: '/watchlist/list/:list_id',
    name: 'ListDetails',
    component: ListDetails,
    meta: {
      requiresAuth: true,
      title: 'ListDetails',
      hideMenu: true,
    },
    props: true,
  },
  {
    path: '/watchlist',
    name: 'MyLists',
    component: MyLists,
    meta: {
      requiresAuth: true,
      title: 'MyLists',
      hideMenu: true,
    },
  },
  {
    path: '/watchlist/recommended',
    name: 'RecommendedView',
    component: RecommendedView,
    meta: {
      requiresAuth: true,
      title: 'Recomendadas',
      hideMenu: true,
    },
  },
  {
    path: '/watchlist/search',
    name: 'SearchMovie',
    component: SearchMovie,
    meta: {
      requiresAuth: true,
      title: 'Search',
    },
  },
  {
    path: '/watchlist/item/:id',
    name: 'MovieDetailPage',
    props: true,
    component: MovieDetailPage,
    meta: {
      requiresAuth: true,
      title: 'Watchlist Item',
      hideMenu: true,
    },
  },
  {
    path: '/baby-tracker/baby/:baby_id/event/:event_id',
    name: 'BabyTracker',
    component: BabyEventEdit,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Baby Tracker',
    },
  },
  {
    path: '/paraguas',
    name: 'afiliacion',
    component: AfiliacionView,
    meta: {
      title: 'Afiliación Paraguas',
    },
  },
  {
    path: '/groceries',
    name: 'groceries',
    component: GroceriesView,
    meta: {
      title: 'Lista de la compra',
    },
  },
  {
    path: '/rocio-2024',
    name: 'RocioView',
    component: RocioView,
    meta: {
      requiresAuth: true,
      title: 'Rocío',
    },
  },
  {
    path: '/todos',
    name: 'TodosViewVue',
    component: TodosViewVue,
    meta: {
      requiresAuth: true,
      title: 'Tasks',
    },
  },
  {
    path: '/facturas',
    name: 'AutonomoView',
    component: AutonomoView,
    meta: {
      requiresAuth: true,
      title: 'Facturas',
    },
  },
  {
    path: '/barcode',
    name: 'BarcodeScanner',
    component: BarcodeScanner,
    meta: {
      title: 'Scanner Demo',
    },
  },
  {
    path: '/friends',
    name: 'FriendsView',
    component: FriendsView,
    meta: {
      requiresAuth: true,
      title: 'Friends',
    },
  },
  {
    path: '/quotes',
    name: 'QuotesView',
    component: QuotesView,
    meta: {
      requiresAuth: true,
      title: 'Quotes',
    },
  },
  {
    path: '/food/items',
    name: 'FoodView',
    component: FoodView,
    meta: {
      requiresAuth: true,
      savePosition: true,
      title: 'Comidas',
    },
  },
  {
    path: '/food/menus',
    name: 'MenusView',
    component: MenusView,
    meta: {
      requiresAuth: true,
      savePosition: true,
      title: 'Menús',
    },
  },
  {
    path: '/food/item/:id',
    name: 'FoodDetail',
    component: FoodDetail,
    props: true,
    meta: {
      requiresAuth: true,
      savePosition: false,
      title: 'Comidas',
    },
  },
  // Google Calendar
  {
    path: '/gcalendar/',
    name: 'GCalendarView',
    component: GCalendarView,
    props: true,
    meta: {
      requiresAuth: true,
      savePosition: true,
      title: 'Calendar',
    },
  },
  {
    path: '/gcalendar/event/:event_id?',
    name: 'CalendarEdit',
    component: CalendarEdit,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Calendar',
      //savePosition: true,
    },
  },

  {
    path: '/tasks',
    name: 'TasksView',
    component: TasksView,
    meta: {
      requiresAuth: true,
      title: 'Tasks',
    },
  },
  {
    path: '/settings',
    name: 'SettingsView',
    component: SettingsView,
    meta: {
      requiresAuth: true,
      title: 'Settings',
    },
  },
  {
    path: '/embarazo',
    name: 'embarazo',
    component: PregnacyView,
    meta: {
      requiresAuth: true,
      title: 'Embarazo',
    },
  },
  {
    path: '/list-asins',
    name: 'lists-asins',
    component: ListAsins,
    meta: {
      requiresAuth: true,
      title: 'Share Asins',
    },
  },
  {
    path: '/share-asins',
    redirect: 'list-asins',
    meta: {
      requiresAuth: true,
      title: 'Share Asins',
    },
  },
  {
    path: '/text',
    name: 'text',
    component: TextEditor,
    meta: {
      requiresAuth: true,
      title: 'Text Editor',
    },
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthView,
    meta: {
      requiresAuth: false,
      title: 'Auth',
    },
  },
  {
    path: '/misas',
    name: 'misas',
    component: MisasView,
    meta: {
      requiresAuth: true,
      title: 'Misas',
    },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutView,
    meta: {
      requiresAuth: false,
      title: 'About',
    },
  },

  {
    path: '/privacidad',
    name: 'privacidad',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: PrivacyPolicy,
    meta: {
      requiresAuth: false,
      title: 'Privacy Policy',
    },
  },
  {
    path: '/code',
    name: 'Code',
    component: CodeIndexView,
    meta: {
      requiresAuth: true,
      title: 'Code',
    },
  },
  {
    path: '/code/sublime-autocompletion',
    name: 'CodeSublimeView',
    component: CodeSublimeView,
    meta: {
      requiresAuth: true,
      title: 'Sublime Autocompletion',
    },
  },
  {
    path: '/code/javadoc',
    name: 'javadoc',
    component: CodeJavadocView,
    meta: {
      requiresAuth: false,
      title: 'Javadoc',
    },
  },
  {
    path: '/code/typedef2interface',
    name: 'typedef2interface',
    component: Typedef2Interface,
    meta: {
      requiresAuth: false,
      title: 'Typedef to Interface',
    },
  },
  {
    path: '/code/shamir',
    name: 'SecretShare',
    component: SecretShare,
    meta: {
      requiresAuth: true,
      title: 'Secret Share',
    },
  },
  {
    path: '/code/icons',
    name: 'icons-generator',
    component: IconsGenerator,
    meta: {
      requiresAuth: true,
      title: 'Icons Generator',
    },
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    //https://router.vuejs.org/guide/advanced/scroll-behavior.html

    if (to.matched.some((record) => record.meta.savePosition) && savedPosition) {
      //return savedPosition with some delay to let things load... maybe there is a better way
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 500)
      })
    }

    //If your browser supports scroll behavior, you can make it smooth:
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      }
    }

    //else, go to top

    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  mode: 'history',
})

router.beforeEach((to, from, next) => {
  //TODO: maybe check if token has expired.
  if (to.meta?.requiresAuth) {
    const token = localStorage.token
    if (!token) next('/auth?redirect=' + to.path)
    else next()
  } else next()
})
export default router
